import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const TelegramRedirectPopup = ({ isOpen, onClose, redirectLink }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleRedirect = () => {
    if (redirectLink) {
      window.open(redirectLink, '_blank');
    }
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="bonus-confirm-overlay"
      onClick={handleOverlayClick}
    >
      <div
        className="bonus-confirm-popup"
        style={{
          textAlign: 'center'
        }}
      >
        {/* Header with close button */}
        <div className="bonus-confirm-header">
          <button
            className="close-button"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        {/* Telegram Icon */}
        <div style={{ marginBottom: '20px' }}>
        <svg width="80" height="80" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="14" fill="url(#paint0_linear_87_7225)"/>
<path d="M22.9866 10.2088C23.1112 9.40332 22.3454 8.76755 21.6292 9.082L7.36482 15.3448C6.85123 15.5703 6.8888 16.3483 7.42147 16.5179L10.3631 17.4547C10.9246 17.6335 11.5325 17.541 12.0228 17.2023L18.655 12.6203C18.855 12.4821 19.073 12.7665 18.9021 12.9426L14.1281 17.8646C13.665 18.3421 13.7569 19.1512 14.314 19.5005L19.659 22.8523C20.2585 23.2282 21.0297 22.8506 21.1418 22.1261L22.9866 10.2088Z" fill="white"/>
<defs>
<linearGradient id="paint0_linear_87_7225" x1="16" y1="2" x2="16" y2="30" gradientUnits="userSpaceOnUse">
<stop stop-color="#37BBFE"/>
<stop offset="1" stop-color="#007DBB"/>
</linearGradient>
</defs>
</svg>
        </div>

        {/* Message */}
        <h3 style={{ 
          color: '#00D328', 
          marginBottom: '16px',
          fontSize: '20px',
          fontWeight: '600'
        }}>
          {t('telegram.title', 'Lütfen Adımları Takip Edin')}
        </h3>

        <p style={{ 
          color: 'white', 
          marginBottom: '24px',
          fontSize: '16px',
          lineHeight: '1.5'
        }}>
          {t('telegram.message', 'Değerli üyemiz, deneme bonusu talep edebilmek için lütfen telegram adımlarımızı takip edin.')}
        </p>

        {/* Buttons */}
        <div className="bonus-confirm-actions">
          <button
            className="bonus-confirm-button"
            onClick={handleRedirect}
          >
            {t('buttons.redirect', 'Yönlendir')}
          </button>

          <button
            className="bonus-cancel-button"
            onClick={onClose}
          >
            {t('buttons.cancel', 'Vazgeç')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TelegramRedirectPopup;
